import { Button } from "react-bootstrap";
import { RiExternalLinkLine, RiStore2Line } from "react-icons/ri";
import OrderFact from "./OrderFact";
import { formatMoney, getNonZeroItemFacts } from "./orderWorkspaceFormatters";
import { canMoveItemToMall } from "./orderWorkspaceRules";
import styles from "./OrdersWorkspace.module.css";

export default function OrderItemRow({ order, source, item, moving, onMoveItem }) {
  return <div className={styles.itemRow}>
    <div className={styles.itemIdentity}>
      {item.product_primary_image ? <img src={`${process.env.REACT_APP_URL_S3}/${item.product_primary_image}`} alt="" /> : <span className={styles.itemPlaceholder} />}
      <div>
        <strong>{item.product_title || "Untitled listing"}</strong>
        <span>{[item.condition, item.category].filter(Boolean).join(" · ") || "Listing"}</span>
        {item.product_url && <a href={item.product_url} target="_blank" rel="noopener noreferrer" className={styles.productLink}><RiExternalLinkLine aria-hidden="true" />View on marketplace</a>}
      </div>
    </div>
    <div className={styles.itemFacts}>
      <OrderFact label="Quantity" value={String(item.quantity || 0)} />
      <OrderFact label="Price" value={formatMoney(item.original_price)} />
      {getNonZeroItemFacts(item).map((fact) => <OrderFact key={fact.label} label={fact.label} value={formatMoney(fact.value)} />)}
    </div>
    <div className={styles.itemAction}>
      {canMoveItemToMall(source) && <Button className={styles.compactAction} size="sm" variant="outline-primary" disabled={moving} onClick={() => onMoveItem(order, source, item)}><RiStore2Line aria-hidden="true" />{moving ? "Moving…" : "Move to TechBazaar Mall"}</Button>}
    </div>
  </div>;
}
